import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Mente llena y decisiones abrumadoras', 'Quieres gastar menos sin dietas restrictivas', 'Necesitas flexibilidad, no perfección', 'Buscas orden sin rigidez'];
  const notForYou = ['Planes rígidos de conteo de macros', 'Recetas gourmet complicadas', 'Dependencia de motivación constante', 'Dietas restrictivas para perder peso rápido'];
  return <Section background="cream" data-id="element-128">
      <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-10 text-center" data-id="element-129">
        ¿Es para ti?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-130">
        <div className="bg-white p-6 rounded-xl border-t-4 border-[#1e3a8a]" data-id="element-131">
          <h3 className="text-xl font-bold text-[#1F2937] mb-4" data-id="element-132">
            ✓ Es para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-133">
            {forYou.map((item, i) => <li key={i} className="flex items-start text-sm" data-id="element-134">
                <CheckCircle2 className="w-4 h-4 text-[#1e3a8a] mr-2 mt-0.5 flex-shrink-0" data-id="element-135" />
                <span className="text-[#4B5563]" data-id="element-136">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-white/50 p-6 rounded-xl border border-gray-200" data-id="element-137">
          <h3 className="text-xl font-bold text-gray-400 mb-4" data-id="element-138">
            ✗ NO es para ti si buscas:
          </h3>
          <ul className="space-y-3" data-id="element-139">
            {notForYou.map((item, i) => <li key={i} className="flex items-start text-sm" data-id="element-140">
                <XCircle className="w-4 h-4 text-gray-300 mr-2 mt-0.5 flex-shrink-0" data-id="element-141" />
                <span className="text-gray-500" data-id="element-142">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}